"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The ServiceLifeCycle model module.
 * @module model/ServiceLifeCycle
 * @version 3.0
 */
var ServiceLifeCycle = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ServiceLifeCycle</code>.
   * @alias module:model/ServiceLifeCycle
   */
  function ServiceLifeCycle() {
    _classCallCheck(this, ServiceLifeCycle);
    ServiceLifeCycle.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(ServiceLifeCycle, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>ServiceLifeCycle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ServiceLifeCycle} obj Optional instance to populate.
     * @return {module:model/ServiceLifeCycle} The populated <code>ServiceLifeCycle</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ServiceLifeCycle();
        if (data.hasOwnProperty('currentstatus')) {
          obj['currentstatus'] = _ApiClient["default"].convertToType(data['currentstatus'], 'String');
        }
        if (data.hasOwnProperty('idleExpireDate')) {
          obj['idleExpireDate'] = _ApiClient["default"].convertToType(data['idleExpireDate'], 'Date');
        }
        if (data.hasOwnProperty('activeExpireDate')) {
          obj['activeExpireDate'] = _ApiClient["default"].convertToType(data['activeExpireDate'], 'Date');
        }
        if (data.hasOwnProperty('barringExpireDate')) {
          obj['barringExpireDate'] = _ApiClient["default"].convertToType(data['barringExpireDate'], 'Date');
        }
        if (data.hasOwnProperty('suspendExpireDate')) {
          obj['suspendExpireDate'] = _ApiClient["default"].convertToType(data['suspendExpireDate'], 'Date');
        }
        if (data.hasOwnProperty('poolExpireDate')) {
          obj['poolExpireDate'] = _ApiClient["default"].convertToType(data['poolExpireDate'], 'Date');
        }
        if (data.hasOwnProperty('fraudCount')) {
          obj['fraudCount'] = _ApiClient["default"].convertToType(data['fraudCount'], 'Number');
        }
        if (data.hasOwnProperty('blackListed')) {
          obj['blackListed'] = _ApiClient["default"].convertToType(data['blackListed'], 'Boolean');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ServiceLifeCycle</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ServiceLifeCycle</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['currentstatus'] && !(typeof data['currentstatus'] === 'string' || data['currentstatus'] instanceof String)) {
        throw new Error("Expected the field `currentstatus` to be a primitive type in the JSON string but got " + data['currentstatus']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} currentstatus
 */
ServiceLifeCycle.prototype['currentstatus'] = undefined;

/**
 * @member {Date} idleExpireDate
 */
ServiceLifeCycle.prototype['idleExpireDate'] = undefined;

/**
 * @member {Date} activeExpireDate
 */
ServiceLifeCycle.prototype['activeExpireDate'] = undefined;

/**
 * @member {Date} barringExpireDate
 */
ServiceLifeCycle.prototype['barringExpireDate'] = undefined;

/**
 * @member {Date} suspendExpireDate
 */
ServiceLifeCycle.prototype['suspendExpireDate'] = undefined;

/**
 * @member {Date} poolExpireDate
 */
ServiceLifeCycle.prototype['poolExpireDate'] = undefined;

/**
 * @member {Number} fraudCount
 */
ServiceLifeCycle.prototype['fraudCount'] = undefined;

/**
 * @member {Boolean} blackListed
 */
ServiceLifeCycle.prototype['blackListed'] = undefined;
var _default = exports["default"] = ServiceLifeCycle;